<template>
  <div class="container-lg contenedor">
    <ModalInfoBeneficio
        ref="modalBeneficio"
        :esUsuario="EsUsuario"
        :service="Service"
        @close="modalBeneficioClosed"
        v-on:suscribiendo="suscribiendoABeneficio"
      />
    <div class="header">
      <div class="botones d-flex border">
        <button type="button" class="btn btn-link" @click="clickVolver">
          Volver
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          data-bs-toggle="collapse"
          data-bs-target="#filtro"
          aria-expanded="false"
          aria-controls="filtro"
        >
          Filtrar
        </button>
      </div>

      <div class="collapse filtro" id="filtro">
        <Filtro
          v-on:cambio-buscar-por="filtroBuscarPorCambiado"
          v-on:cambio-ordenar-por="filtroOrdenarPorCambiado"
        />
      </div>
    </div>
    <div class="resultados">
      <div
        id="accordionExample"
        class="accordion open"
        v-on:[`hide.bs.collapse`]="accordionCerrado()"
      >
        <div
          class="accordion-item"
          v-on:[`shown.bs.collapse`]="accordionExpandido(0)"
        >
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Beneficios
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <TarjetasBeneficio
                ref="beneficios"
                :busqueda="busqueda"
                :cargaManual="true"
                :infoSinResultados="'Prueba cambiar la búsqueda o aplicar otros filtros'"
                :service="Service"
                @click-beneficio="openModalBeneficio"
              />
            </div>
          </div>
        </div>
        <div
          class="accordion-item"
          v-on:[`shown.bs.collapse`]="accordionExpandido(1)"
        >
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Comercios
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <TarjetasComercio
                ref="comercios"
                :busqueda="busqueda"
                :cargaManual="true"
                :infoSinResultados="'Prueba cambiar la búsqueda o aplicar otros filtros'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icons as IconConstants } from "../../constants";

import { BeneficioAfiliadoService } from "../../servicios/cliente/afiliado/beneficio.afiliado.service";
import { BeneficioVisitaService } from "../../servicios/cliente/visita/beneficio.visita.service";
import { BuscarPor, OrdenarPor } from "../../data/enums";
import Filtro from "../../components/Filtro";
import ModalInfoBeneficio from "../../components/cliente/ModalInfoBeneficio";
import TarjetasBeneficio from "../../components/TarjetasBeneficio";
import TarjetasComercio from "../../components/TarjetasComercio";
import { Util } from "../../util";

export default {
  name: "Busqueda",
  components: {
    Filtro,
    ModalInfoBeneficio,
    TarjetasBeneficio,
    TarjetasComercio,
  },
  data() {
    return {
      busqueda: {
        valor: this.Busqueda,
        buscarPor: BuscarPor.comercio,
        ordenarPor: OrdenarPor.relevancia,
      },
      // Se utilizan para no recargar datos si una búsqueda ya se hizo
      busquedasCacheadas: {
        beneficios: null,
        comercios: null,
      },
      idUsuario: null,
      indiceAccordion: 0,
      token: null,
    };
  },
  computed: {
    /**Verdadero si es un usuario logeado */
    EsUsuario() {
      return this.idUsuario != null && this.token != null;
    },
    Icons() {
      return IconConstants;
    },
    /**Texto buscado */
    Busqueda() {
      return this.$route.params.busqueda;
    },
    Service(){
      return this.EsUsuario ? BeneficioAfiliadoService : BeneficioVisitaService;
    },
  },
  watch: {
    Busqueda(valor) {
      this.busquedaCambiada(valor);
    },
  },
  methods: {
    // Se llama cuando se cierra un accordion-item
    // Tener en cuenta que al abrirse uno, primero se cierra el que estaba abierto antes
    // (Si es que había uno abierto)
    accordionCerrado() {
      this.indiceAccordion = null;
    },
    accordionExpandido(indice) {
      this.indiceAccordion = indice;

      this.tratarActualizacion();
    },
    busquedaCambiada(valor) {
      // Se recrea el objeto para que se activen los triggers que detectan el cambio en Tarjetas
      this.busqueda = {
        valor: valor,
        buscarPor: this.busqueda.buscarPor,
        ordenarPor: this.busqueda.ordenarPor,
      };

      this.tratarActualizacion();
    },
    clickVolver() {
      this.volver();
    },
    filtroBuscarPorCambiado(valor) {
      if (valor == this.busqueda.buscarPor) return;

      // Reconstruir el objeto para que se detecten los cambios en los componentes que lo usan
      this.busqueda = {
        valor: this.busqueda.valor,
        buscarPor: valor,
        ordenarPor: this.busqueda.ordenarPor,
      };

      this.tratarActualizacion();
    },
    filtroOrdenarPorCambiado(valor) {
      if (valor == this.busqueda.ordenarPor) return;

      // Reconstruir el objeto para que se detecten los cambios en los componentes que lo usan
      this.busqueda = {
        valor: this.busqueda.valor,
        buscarPor: this.busqueda.buscarPor,
        ordenarPor: valor,
      };

      this.tratarActualizacion();
    },
    // Se fija si la lista en el accordion expandido necesita actualizarse
    tratarActualizacion() {
      switch (this.indiceAccordion) {
        // Beneficios
        case 0:
          if (this.verSiEsDistinta(this.busquedasCacheadas.beneficios)) {
            // Se hace una copia profunda para que no queden valores enlazados
            // Con enlazado me refiero a que al cambiar en un objeto cambien en el otro
            this.busquedasCacheadas.beneficios = Util.copiaProfunda(
              this.busqueda
            );
            // Llamar al EventoRecargar dentro del componente referenciado
            this.$refs.beneficios.EventoRecargar(this.busqueda);
          }
          break;
        // Comercios
        case 1:
          if (this.verSiEsDistinta(this.busquedasCacheadas.comercios)) {
            // Se hace una copia profunda para que no queden valores enlazados
            // Con enlazado me refiero a que al cambiar en un objeto cambien en el otro
            this.busquedasCacheadas.comercios = Util.copiaProfunda(
              this.busqueda
            );
            // Llamar al EventoRecargar dentro del componente referenciado
            this.$refs.comercios.EventoRecargar(this.busqueda);
          }
          break;
        default:
          break;
      }
    },
    openModalBeneficio(beneficio) {
      this.$refs.modalBeneficio.abrir(beneficio.id, beneficio.suscripto);
    },
    modalBeneficioClosed() {},
    // Cuando usuario se suscribe a un beneficio
    // Se recibe {promesa, beneficio}, la promesa es la petición de suscripción
    // Al server, cuando esta se cumpla significa que se suscribió correctamente
    suscribiendoABeneficio(promesaYBeneficio) {
      promesaYBeneficio.promesa.then(() => {
        this.suscriptoABeneficio(promesaYBeneficio.beneficio.id);
      });
    },
    /**Eliminar un beneficio de la lista cuando se suscribe al beneficio */
    suscriptoABeneficio(beneficioId) {
      this.$store.commit("beneficioUpdate", {beneficioId, data: {suscripto: true}});
    },
    /** Verdadero si la búsqueda cacheada es distinta a la actual */
    verSiEsDistinta(cacheada) {
      if (cacheada == null) return true;

      if (cacheada.valor != this.busqueda.valor) return true;

      if (cacheada.buscarPor != this.busqueda.buscarPor) return true;

      if (cacheada.ordenarPor != this.busqueda.ordenarPor) return true;

      return false;
    },
    volver() {
      this.$router.push({ name: 'cliente.home' });
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.idUsuario = localStorage.getItem("iduser");

    // Inicializar busqueda, esto también carga los beneficios
    this.busquedaCambiada(this.$route.params.busqueda);
  },
};
</script>
<style scoped>
.contenedor {
  padding-top: 15px;
  padding-bottom: 15px;
}
.header {
  padding-bottom: 15px;
}
.botones {
  background-color: #eee;
}
.volver {
  padding-top: 25px;
  padding-bottom: 25px;
}
.volver button {
  color: var(--color-estructura-a);
}

.accordion-header {
  background-color: #eee;
}
</style>
